"use client";

import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const categories = [{
  id: "civil",
  title: "Гражданские споры"
}, {
  id: "family",
  title: "Семья и наследство"
}, {
  id: "business",
  title: "Арбитраж и бизнес"
}, {
  id: "consult",
  title: "Правовая поддержка"
}];
const services = [{
  categoryId: "civil",
  name: "Земельные споры",
  desc: "Межевание, установление границ, признание прав на земельные участки и оспаривание кадастровой стоимости.",
  price: "от 45 000 ₽"
}, {
  categoryId: "civil",
  name: "Защита собственности",
  desc: "Истребование имущества из чужого владения, устранение препятствий в пользовании и признание права собственности.",
  price: "от 60 000 ₽"
}, {
  categoryId: "civil",
  name: "Договорные споры",
  desc: "Взыскание задолженности по договорам займа, подряда, аренды. Расторжение договоров в судебном порядке.",
  price: "от 40 000 ₽"
}, {
  categoryId: "family",
  name: "Семейные дела",
  desc: "Расторжение брака, раздел совместно нажитого имущества, споры о детях и взыскание алиментов.",
  price: "от 50 000 ₽"
}, {
  categoryId: "family",
  name: "Наследственные споры",
  desc: "Восстановление срока принятия наследства, оспаривание завещаний, выдел обязательной доли в наследстве.",
  price: "от 70 000 ₽"
}, {
  categoryId: "business",
  name: "Арбитражные споры",
  desc: "Представительство в арбитражных судах всех инстанций по экономическим спорам и корпоративным конфликтам.",
  price: "от 85 000 ₽"
}, {
  categoryId: "business",
  name: "Взыскание долгов (B2B)",
  desc: "Комплексная работа по возврату дебиторской задолженности, включая стадию исполнительного производства.",
  price: "от 50 000 ₽"
}, {
  categoryId: "business",
  name: "Абонентское обслуживание",
  desc: "Полное юридическое сопровождение бизнеса: договорная работа, комплаенс и защита интересов в госорганах.",
  price: "от 35 000 ₽/мес"
}, {
  categoryId: "consult",
  name: "Юридическая консультация",
  desc: "Устный или письменный правовой анализ ситуации с учетом актуальной судебной практики Калужской области.",
  price: "от 5 000 ₽"
}, {
  categoryId: "consult",
  name: "Судебные документы",
  desc: "Составление исковых заявлений, апелляционных жалоб, претензий и ходатайств любой сложности.",
  price: "от 10 000 ₽"
}];
export default function AllServices() {
  return <section data-section-id="153588" id="юридическая-помощь" className="bg-background text-foreground py-24 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight uppercase font-serif text-primary">
            Юридическая помощь
          </h2>
          <p className="mt-4 text-lg text-secondary font-sans max-w-2xl">
            Профессиональная защита ваших интересов в Калуге. Прозрачное
            ценообразование и строгий академический подход к каждому делу.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-12 items-start relative">
          <div className="hidden lg:block sticky top-24">
            <nav className="flex flex-col border-l border-border">
              {categories.map((category, index) => <div key={category.id} data-index={index}>
                  <Link to={`#category-${category.id}`} className="block w-full">
                    <Button variant="ghost" className="w-full justify-between text-left font-medium rounded-none border-l-2 border-transparent hover:border-primary hover:bg-accent hover:text-accent-foreground px-6 py-6 h-auto transition-all font-sans">
                      {category.title}
                      <ChevronRight className="size-4 opacity-50" />
                    </Button>
                  </Link>
                  {index < categories.length - 1 && <Separator className="ml-6 w-[calc(100%-1.5rem)] opacity-50" />}
                </div>)}
            </nav>
          </div>

          <div className="flex flex-col gap-16">
            {categories.map((category, index) => {
            const categoryServices = services.filter(s => s.categoryId === category.id);
            return <div key={category.id} id={`category-${category.id}`} data-index={index} className="scroll-mt-32">
                  <h3 className="text-2xl font-bold tracking-tight mb-6 uppercase border-b border-border pb-4 font-serif text-primary">
                    {category.title}
                  </h3>
                  
                  <Table>
                    <TableHeader>
                      <TableRow className="hover:bg-transparent border-border">
                        <TableHead className="w-[30%] text-secondary font-semibold uppercase tracking-widest text-xs font-mono">
                          Направление
                        </TableHead>
                        <TableHead className="w-[50%] text-secondary font-semibold uppercase tracking-widest text-xs font-mono">
                          Описание помощи
                        </TableHead>
                        <TableHead className="text-right text-secondary font-semibold uppercase tracking-widest text-xs font-mono">
                          Гонорар
                        </TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {categoryServices.map((service, sIndex) => <TableRow key={sIndex} data-index={sIndex} className="border-border hover:bg-accent/5 transition-colors">
                          <TableCell className="font-semibold align-top py-6 font-sans text-primary">
                            {service.name}
                          </TableCell>
                          <TableCell className="text-secondary align-top py-6 leading-relaxed font-sans">
                            {service.desc}
                          </TableCell>
                          <TableCell className="text-right align-top py-6 whitespace-nowrap font-medium font-mono text-primary">
                            {service.price}
                          </TableCell>
                        </TableRow>)}
                    </TableBody>
                  </Table>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}